<template>
    <div class="position: relative"> 
        <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col vs-type="flex" vs-justify="flex-end" class="filter-top">
                <!-- <vs-checkbox size="large" v-model="filter.openedTablesOnly" class="mr-2" > Mesas Abertas </vs-checkbox> -->
                <a-radio-group default-value="a" button-style="solid" v-model="filter.tableStatus">
                    <a-radio-button value="a">
                        Todas
                    </a-radio-button>
                    <a-radio-button value="b">
                        Vazias
                    </a-radio-button>
                    <a-radio-button value="c">
                        Abertas
                    </a-radio-button>
                </a-radio-group>
            </vs-col>
        </vs-row>
        <div class="vx-row match-height" id="mainDiv">
            <div
                class="vx-col sm:w-6/12 md:w-6/12 lg:w-2/12 w-6/12 yes-drop dropzone cursor-pointer"
                v-for="bill in availableTables" 
                :key="bill.id" 
                :id="bill.id ? bill.id : bill.table.id"
                >
                <vx-card
                    class="mb-base overflow-hidden select-none"
                    :class="{
                        'border border-dashed d-theme-border-grey-light border-r-4 border-b-4 border-l-4 border-t-4' : dragAndDrop.active && dragAndDrop.fromBillId != bill.id,
                     }"
                    style="position:relative"
                    card-background="#fefef8"
                >
                    
                    <div class="hover flex items-center justify-center" v-if="!dragAndDrop.active && !bill.id" slot="body" @click="selectBill(bill)">
                        <div class="flex items-center" style="flex-direction: column;">
                            <a-icon type="plus" style="font-size: 50pt"/>
                            <h4 class="mt-3 text-white"><b>Abrir mesa</b></h4>
                        </div>
                    </div>

                    <div v-if="busyStatus[bill.id]"
                        slot="body"
                        class="busy-table"
                    ></div>
                    <template slot="no-body">

                        <div class="flex flex-wrap" @click="transferOrMerge(bill.id)">
                            <div
                                :class="bill.id ? 'bg-primary' : 'bg-grey'"
                                class="item-view-secondary-action-btn p-3 flex flex-grow items-center justify-center text-white h-12">
                                <feather-icon icon="RepeatIcon" svgClasses="h-4 w-4" />
                                <span class="text-sm ml-2" v-if="windowWidth <= 1170"> ALTERAR </span>
                                <span class="text-sm ml-2" v-if="windowWidth > 1170"> ALTERAR MESAS </span>
                            </div>
                        </div>

                        <div @click="selectBill(bill)" class="pt-4">
                            <div class="flex items-center justify-center">
                                <h1 
                                    :style="windowWidth <= 1170 ? 'font-size: 22px' : ''"
                                    :class="!bill.id ? 'mr-4 ml-4 text-grey' : ''"
                                    class="font-bold">
                                    MESA {{ bill.table.number }}
                                </h1>
                            </div>
                            
                            <div class="item-details px-4 mt-2 mb-2">
                                <div class="flex justify-center items-center">
                                    
                                    <h5 class="font-bold" :class="!bill.id ? 'text-grey' : ''">
                                        <span v-if="windowWidth > 480"> R$ </span>
                                        <span v-if="windowWidth <= 480"> {{ bill.value | currency }} </span>
                                        <number
                                            v-if="windowWidth > 480"
                                            ref="totalPaid"
                                            :to="bill.id ? bill.value : 0"
                                            :format="(number) => number.toFixed(2).replace('.', ',')"
                                            :duration="1"
                                            easing="Power1.easeOut"/>
                                    </h5>
                                </div>
                                <div class="flex justify-center mb-4">
                                    <span class="text-sm" :class="!bill.id ? 'text-grey' : ''"> 
                                        <a-icon type="clock-circle" v-if="bill.timeSinceOpened" />  
                                        <a-icon type="loading" v-if="!bill.timeSinceOpened && bill.id" />
                                        {{ bill.id ? bill.timeSinceOpened : 'FECHADA' }}</span>
                                </div>
                            </div>
                            <!-- <div class="flex flex-wrap">
                                <div
                                    :class="bill.id ? 'bg-primary' : 'bg-grey'"
                                    class="item-view-secondary-action-btn p-3 flex flex-grow items-center justify-center text-white">
                                    <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                                    <span class="text-sm ml-2"> {{ bill.id ? 'VISUALIZAR MESA' : 'MESA FECHADA' }} </span>
                                </div>
                            </div> -->
                        </div>
                    </template>
                </vx-card>
            </div>
        </div>
        
        <modal-users-orders 
            :visible="modalBillUsersOrders.visible"
            :table="modalBillUsersOrders.table"
            @close="(value) => modalBillUsersOrders.visible = value"
            @add-order="addItemToTable"
        />

        <modal-table-transf-merg 
            :visible="modalTableTransf.visible"
            :bills="availableTables"
            :fromBillId="modalTableTransf.fromBillId"
            :toBillId="dragAndDrop.toBillId"
            :toTableId="dragAndDrop.toTableId"
            @close="(value) => modalTableTransf.visible = value"
        />

        <!-- <a-modal
            :wrapStyle="{ top: '-100px' }"
            :maskClosable="true"
            :width="windowWidth"
            :zIndex="90000"
            :footer="null"
            :title="`Adicionar Pedidos - Mesa ${modalNewOrder.table && modalNewOrder.table.table.number}`"
            destroyOnClose
            @cancel="cleanUpOrdersOnBag"
            v-model="modalNewOrder.visible">
            <new-order
                :forDelivery="false"
                :table="modalNewOrder.table"
                @saved="onSaved"
            />
        </a-modal> -->
<!-- 
        <new-order
            :visible="modalNewOrder.visible"
            :forDelivery="false"
            :table="modalNewOrder.table"
            @close="onCloseModalNewOrder"
            @saved="onCloseModalNewOrder"
        />
         -->
         
        <vs-popup 
            fullscreen 
            :title="`MESA ${modalNewOrder.table && modalNewOrder.table.table.number}`"
            :active.sync="modalNewOrder.visible"
            style="zIndex: 99998; height: 100%">
            <new-order
                style="height: 100%"
                :forDelivery="false"
                :visible="modalNewOrder.visible"
                :table="modalNewOrder.table"
                @saved="onSaved"
                />
        </vs-popup>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import ModalUsersOrders from './ModalUsersOrders'
    import ModalTableTransfMerg from './ModalTableTransfMerg'
    import NewOrder from './NewOrder'
    import { STATUS_CANCELED, STATUS_PAID } from '@/assets/utils/constants.js'
    import interact from 'interactjs'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import { mapMutations, mapState } from 'vuex'
    import _misc, { elapsedTime } from '@/assets/utils/misc.js'

    export default {
        components : {
            ModalUsersOrders,
            ModalTableTransfMerg,
            NewOrder,
            VuePerfectScrollbar
        },

        data () {
            return {
                filter : {
                    tableStatus : 'a'
                },
                ref : firebase.firestore(),
                bills : [],
                tables: [], // (Closed tables) This will join with bills
                modalBillUsersOrders : {
                    visible : false
                },
                modalTableTransf : {
                    fromBillId : '',
                    visible : false
                },
                modalNewOrder: {
                    table: null,
                    visible : false
                },
                dragAndDrop : {
                    active : false,
                    fromBillId : '',
                    toBillId : '',
                    toTableId : '',
                    pos : { x :0, y: 0}
                },
            }
        },

        computed: {
            windowWidth() {
                return this.$store.state.windowWidth
            },

            availableTables () {
                let closedTables = this.joinClosedTablesInBill();
                let bills = [...this.bills, ...closedTables];
                return bills.sort((a, b) => a.table.number - b.table.number)
                    .filter(table => {
                        switch(this.filter.tableStatus) {
                            case 'a' :
                                return true
                                break;
                            case 'b' :
                                return table.isClosed == true
                                break;
                            case 'c' :
                                return table.isClosed == false
                                break;
                        }
                    })
            },

            ...mapState('bill', ['busyStatus'])
        },

        created () {
            setInterval(this.getTimeSinceOpened, 500)
        },

        mounted () {
            var that = this

            this.$message.config({ top: '80px'})
            this.getBills()
            this.getTables()

            interact('.draggableTable')
                .draggable({
                    hold : 300,
                    intertia : true,
                    modifiers: [
                        interact.modifiers.restrictRect({
                            restriction: 'parent',
                            endOnly: true
                        })
                    ],
                    autoScroll: true,
                    listeners : {
                        move  : this.dragMoveListener,
                        // start : this.dragStartListener,
                        end   : this.dragEndListener,
                        hold  : this.dragMoveListener
                    }
                })           

            interact('.dropzone').dropzone({
                accept: '.yes-drop',
                overlap: 0.5,
                ondropactivate: function (event) {
                    // add active dropzone feedback
                    // event.target.classList.add('drop-active')
                },
                ondragenter: function (event) {
                    let draggableElement = event.relatedTarget
                    let dropzoneElement = event.target

                    dropzoneElement.classList.add('drop-target')
                    draggableElement.classList.add('can-drop')
                },
                ondragleave: function (event) {
                    event.target.classList.remove('drop-target')
                    event.relatedTarget.classList.remove('can-drop')
                },
                ondrop: function (event) {
                    let draggableElement = event.relatedTarget
                    let dropzoneElement = event.target

                    let toBillId = dropzoneElement.id == that.getTableIdFromBill(dropzoneElement.id) ? '' : dropzoneElement.id
                    let toTableId = toBillId == dropzoneElement.id ? '' : dropzoneElement.id

                    that.$set(that.dragAndDrop, 'toBillId', toBillId)
                    that.$set(that.dragAndDrop, 'toTableId', toTableId)
                    that.$set(that.modalTableTransf, 'visible', true)
                },
                ondropdeactivate: function (event) {
                    event.target.classList.remove('drop-active')
                    event.target.classList.remove('drop-target')
                }
            })

        },

        methods : {
            dragMoveListener (event) {
                this.$set(this.dragAndDrop, 'active', true)
                this.$set(this.dragAndDrop, 'fromBillId', event.target.id)

                var target = event.target
                // keep the dragged position in the data-x/data-y attributes
                var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
                var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

                // translate the element
                target.style.webkitTransform =
                    target.style.transform =
                    'translate(' + x + 'px, ' + y + 'px)'

                // update the posiion attributes
                target.setAttribute('data-x', x)
                target.setAttribute('data-y', y)

                target.style.zIndex = 2
            },

            dragStartListener (event) {
                var target = event.target
                var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
                var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy
                
                this.$set(this.dragAndDrop.pos, 'x', x)
                this.$set(this.dragAndDrop.pos, 'y', y)
                
                target.style.zIndex = 2
            },

            dragEndListener (event) {
                var target = event.target
                            
                target.style.transform = `translate(${this.dragAndDrop.pos.x}px, ${this.dragAndDrop.pos.y}px)`
                target.setAttribute('data-x', this.dragAndDrop.pos.x)
                target.setAttribute('data-y', this.dragAndDrop.pos.y)

                target.style.zIndex = 1

                setTimeout(() => {
                    this.$set(this.dragAndDrop, 'active', false)
                }, 20)
                
            },

            cleanUpOrdersOnBag () {
                this.cleanUp()
            },

            transferOrMerge (billId) {
                this.$set(this.modalTableTransf, 'fromBillId', billId)
                this.$set(this.modalTableTransf, 'visible', true)
            },

            async getTables () {
                try {
                    this.$vs.loading()

                    let companyId = this.$store.getters.getCompanyID
                    let tables = await this.ref.collection('company').doc(companyId).collection('tables').where('active', '==', true).get()

                    tables.forEach(table => {
                        this.tables.push({
                            isClosed : true,
                            table : {
                                id : table.id,
                                number : table.data().number
                            }
                        })
                    })
                } catch (err) {
                    this.$error({
                        title: 'Erro ao carregar pedidos!',
                        content: err.message
                    })
                } finally {
                    this.$vs.loading.close();
                }
            },

            joinClosedTablesInBill () {
                let newBill = []

                this.tables.forEach(table => {
                    let isTableInBill = false

                    this.bills.forEach(bill => {
                        if(bill.tableId == table.table.id) {
                            isTableInBill = true
                        }
                    })

                    if(!isTableInBill) 
                        newBill.push(table)
                })

                return newBill
            },

            async getBills () {
                try {
                    this.$vs.loading()
                    let companyId = this.$store.getters.getCompanyID;
                    await this.ref.collection('company').doc(companyId).collection('bill')
                        .orderBy('table.number', 'asc')
                        .where('isClosed', '==', false)
                        .onSnapshot(snapshot => {
                            snapshot.docChanges().forEach(change => {
                                if(change.type === 'added') {
                                    this.bills.push({id: change.doc.id, ...change.doc.data()})
                                }
                                if(change.type === 'modified') {
                                    this.changeBill(change.doc)
                                }
                                if(change.type === 'removed') {
                                    this.removeBill(change.doc)
                                }
                            })
                        })
                } catch(err) {
                    this.$error({
                        title: 'Erro ao carregar pedidos!',
                        content: err.message
                    })
                } finally {
                    this.$vs.loading.close();
                }
            },

            changeBill (doc) {
                var openedTable = this.modalBillUsersOrders.table

                /**
                 * TODO: !!! REFATORAR !!!
                 */

                if(typeof(openedTable) != 'undefined') {
                    
                    if(doc.id == openedTable.id) {
                        // BILL ROOT
                        let newBill = doc.data()
                        this.$set(openedTable, 'isClosed', newBill.isClosed)
                        // openedTable.isClosed  = newBill.isClosed
                        openedTable.isProcessed = newBill.isProcessed
                        this.$set(openedTable, 'value', newBill.value)
                        this.$set(openedTable, 'totalPaid', newBill.totalPaid || 0)
                        this.$set(openedTable, 'taxes', newBill.taxes)
                        this.$set(openedTable, 'taxesValue', newBill.taxesValue || 0)
                        this.$set(openedTable, 'discountValue', newBill.discountValue || 0)
                        this.$set(openedTable, 'standalonePayment', newBill.standalonePayment || 0)

                        // BILL USERS ORDERS
                        let usersOrders = Object.entries(newBill.usersOrders)
                        usersOrders.forEach((newUser) => {
                            if(typeof(openedTable.usersOrders[newUser[0]]) == 'undefined'){
                                this.$set(openedTable.usersOrders, newUser[0], newUser[1])
                            } else {
                                this.$set(openedTable.usersOrders[newUser[0]], 'value', newUser[1].value)

                                // ORDER
                                let orders = Object.entries(newUser[1].orders)
                                orders.forEach(order => {

                                    if(typeof(openedTable.usersOrders[newUser[0]].orders[order[0]]) == 'undefined'){
                                        this.$set(openedTable.usersOrders[newUser[0]].orders, order[0], order[1])
                                    } else {
                                        this.$set(openedTable.usersOrders[newUser[0]].orders[order[0]], 'status', order[1].status)
                                        this.$set(openedTable.usersOrders[newUser[0]].orders[order[0]], 'value', order[1].value)
                                        this.$set(openedTable.usersOrders[newUser[0]].orders[order[0]], 'quantity', order[1].quantity)
                                        this.$set(openedTable.usersOrders[newUser[0]].orders[order[0]], 'obs', order[1].obs)
                                        
                                        if(order[1].status == STATUS_PAID || order[1].status == STATUS_CANCELED) {
                                            this.$delete(openedTable.usersOrders[newUser[0]].orders[order[0]], 'checkedToBePay')
                                        }

                                        // OPTIONS
                                        let options = Object.entries(order[1].options)
                                        options.forEach(opt => {
                                            this.$set(openedTable.usersOrders[newUser[0]].orders[order[0]].options, opt[0], opt[1])
                                        }) 
                                    }
                                })   
                            }                
                        })
                    }
                }

                this.bills.forEach((k, i) => k.id == doc.id ? this.$set(this.bills, i, doc.data()) : '')
            },

            removeBill (doc) {
                var openedTable = this.modalBillUsersOrders.table
                
                if(typeof(openedTable) != 'undefined'){
                    if(openedTable.id == doc.id) {
                        this.$set(this.modalBillUsersOrders, 'visible', false)
                    }
                }

                this.bills.forEach((k, i) => k.id == doc.id ? this.$delete(this.bills, i) : '')
            },

            selectBill (table) {
                if (this.dragAndDrop.active || this.busyStatus[table.id])
                    return;
                if(table.id) {
                    this.$set(this.modalBillUsersOrders, 'table', table)
                    this.$set(this.modalBillUsersOrders, 'visible', true)
                } else
                    this.addItemToTable(table);
            },

            addItemToTable(table) {
                this.modalNewOrder.table = table;
                this.modalNewOrder.visible = true;
            },

            onSaved(val) {
                this.modalNewOrder.table = null;
                this.modalNewOrder.visible = false;
            },

            getTimeSinceOpened () {
                for (let i = 0; i <= this.bills.length - 1; i++) {
                    let table = this.bills[i];

                    if(table.openedOn) {
                        const timeSince = elapsedTime(table.openedOn.toDate())

                        this.$set(this.bills[i], 'timeSinceOpened', timeSince)
                    }
                }
            },

            getTableIdFromBill (billId) {
                let findTable = this.bills.find(bill => billId == bill.id)
                if(findTable) 
                    findTable.table.id 
                else 
                    return billId

                // return billId ? this.bills.find(bill => billId == bill.id).table.id : ''
            },

            ...mapMutations('order', ['cleanUp'])
        }
    }
</script>

<style>
    .draggableTable {
        touch-action: none;
        user-select: none;
        -webkit-transform: translate(0px, 0px);
                transform: translate(0px, 0px);
    }

    #outer-dropzone {
        height: 140px;
    }

    #inner-dropzone {
        height: 80px;
    }

    .dropzone {
        transition: background-color 0.3s;
    }

    .drop-active {
        border-color: #aaa;
    }

    .drop-target {
        /* background-color: #29e; */
        /* border-color: #fff; */
        /* border-style: solid; */
        opacity: 0.4;
        transition: opacity 0.5s;
    }

    .drag-drop.can-drop {
        color: #000;
        background-color: #4e4;
    }

    .hover {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        color: white;
    }
    .hover:hover {
        opacity: 0.75;
        cursor: pointer;
        -webkit-backdrop-filter: blur(5px);
        backdrop-filter: blur(5px);
        background: #00000077;
    }
    .scroll-area-upper { 
        /* height: 80vh */
    }

    .filter-top {
        z-index: 999;
        position: absolute;
        top: -40px;
    }

    .busy-table {
        background: black;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0.35;
        z-index: 999;
    }
    .busy-table::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        opacity: 0.25;
        width: 180%;
        height: 150%;
        z-index: 999;
        background: repeating-linear-gradient(
                white 0%,
                white 7.5px,
                red 7.5px,
                red 15px,
                white 15px,
                white 22.5px,
                red 22.5px,
                red 30px);
        transform: translateX(-20%) translateY(-20%) rotate(-45deg);
        animation: animate 20s linear infinite;
    }
        
    @keyframes animate {
        from {
            background-position: 0;
        }

        to {
            background-position: 0 450px;
        }
    }

</style>